module.exports = __webpack_public_path__ + "media/images/steps/face_shield_step2-5e4d03056259a4224191e3fc68760b33.svg";